interface TestComponentProps {
  name: string;
}

export function TestComponent({ name }: TestComponentProps) {
  return (
    <div class="italic">
      <h2>Hello, {name}!</h2>
      <p>Preact is working.</p>
    </div>
  );
}
